'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sellerDetailComponent = undefined;

var _marked = require('marked');

var _marked2 = _interopRequireDefault(_marked);

var _markedRenderer = require('./../../common/core/markedRenderer');

var _markedRenderer2 = _interopRequireDefault(_markedRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_marked2.default.setOptions({
    renderer: _markedRenderer2.default,
    breaks: false,
    sanitize: true
});

var sellerDetailComponent = exports.sellerDetailComponent = {
    template: require('./detail.html'),
    bindings: {
        seller: '<',
        parentState: '<',
        sellerModules: '<',
        rentalProductsCategories: '<'
    },
    controllerAs: 'vm',
    controller: ["$scope", "newsService", "sellerService", "productOverviewService", "partnershipsService", "Enums", "common", "Analytics", "$state", "lodash", "cartService", "$timeout", "gettextCatalog", "exceptionService", "productService", "$window", "authService", function controller($scope, newsService, sellerService, productOverviewService, partnershipsService, Enums, common, Analytics, $state, lodash, cartService, $timeout, gettextCatalog, exceptionService, productService, $window, authService) {
        'ngInject';

        var vm = this;
        vm.discountsModel = null;
        vm.productsModel = null;
        vm.errorOccurredInDiscountOverview = false;
        vm.newsitems = null;
        vm.initSlider = null;
        vm.addToCart = addToCart;
        vm.sellerBanners = null;
        vm.sellerContent = null;
        vm.errorOccurredInProductOverview = false;
        vm.scrollTo = scrollTo;
        vm.$onInit = init;
        vm.myContacts = [];
        vm.otherContacts = [];
        vm.partnershipsModel = null;
        vm.partnerships = [];
        vm.$onChanges = bindingChanges;
        vm.productQuantityChanged = productQuantityChanged;
        vm.getProductDiscounts = getProductDiscounts;
        vm.moduleEnabled = moduleEnabled;

        function init() {

            //no seller found redirect to error page
            if (!vm.seller) {
                $state.go('error');
            }

            //update quantity on enter
            if (authService.isBuyer) {
                angular.element($window).on('keydown', function (event) {
                    if (event.which === 13 && vm.addingProducts !== true) {
                        vm.addToCart();
                    }
                });

                $scope.$on('$destroy', function () {
                    angular.element($window).off('keydown');
                });
            }

            common.navigationMenu.setSellersActive();
            common.setTitle(vm.seller.name);
            Analytics.trackPage('/' + common.localization.getCurrentLanguage() + '/' + vm.seller.id, vm.seller.name);

            vm.bannerTextAlignmentClasses = Enums.bannerTextAlignmentClasses;

            /* load seller Details */
            sellerService.getBySellerId(vm.seller.id).then(function (sellerContent) {
                vm.sellerContent = sellerContent;
                if (vm.sellerContent.sellerEmployees) {
                    vm.myContacts = lodash.filter(vm.sellerContent.sellerEmployees, function (i) {
                        return i.isMyRepresentative === true;
                    });
                    vm.otherContacts = lodash.filter(vm.sellerContent.sellerEmployees, function (i) {
                        return i.isMyRepresentative === false;
                    });
                }
            });

            /* load seller total price disounts*/
            sellerService.getSellerTotalPriceDiscounts(vm.seller.id).then(function (totalPriceDiscounts) {
                vm.totalPriceDiscounts = totalPriceDiscounts;
            });

            /* load news */
            newsService.getNewsForSellerPage(vm.seller.id).then(function (m) {
                vm.newsitems = m;
            });

            /* load banners */
            sellerService.getSellerBanners(vm.seller.id).then(function (banners) {
                vm.sellerBanners = banners;
                angular.forEach(vm.sellerBanners, function (banner) {
                    Analytics.addPromo(banner.id, banner.name, banner.sequenceNr, '');
                });
                // Analytics.pageView(); // causes double pageview tracking, location is shop.profficina.be
            });

            /* load products and discounts */
            vm.discountsModel = productOverviewService.init(Enums.searchContext.seller.id);
            vm.productsModel = productOverviewService.init(Enums.searchContext.seller.id);
            vm.discountsModel.isLoadingInitial = true;
            vm.productsModel.isLoadingInitial = true;

            sellerService.getSellerProductsAndDiscounts(vm.seller.id, vm.productsModel, vm.discountsModel).then(function (model) {
                vm.productsModel.isLoadingInitial = false;
                vm.discountsModel.isLoadingInitial = false;
                vm.productsModel = model.productsModel;
                vm.discountsModel = model.discountsModel;
                vm.errorOccurredInDiscountOverview = model.discountsModel.errorOccurred;
            });

            /*  load partnerships */
            vm.partnershipsModel = partnershipsService.init();
            partnershipsService.getAll(vm.partnershipsModel, {
                skip: 0,
                take: 4,
                sellerId: vm.seller.id
            }, 1).then(function (model) {
                vm.partnershipsModel = model;
                vm.partnerships = model.partnerships;
                vm.errorOccurredInPartnershipOverview = model.errorOccurred;
            });

            // todo put in service
            /* slider settings */
            vm.heroSliderSettings = {
                autoplay: true,
                autoplaySpeed: 6000,
                draggable: false,
                dots: true,
                arrows: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                responsive: [{
                    breakpoint: 576,
                    settings: {
                        dots: true,
                        arrows: false
                    }
                }]
            };

            /* settings for the product slider */
            vm.productSliderSettings = {
                dots: true,
                arrows: false,
                slidesToShow: 5,
                slidesToScroll: 5,
                touchMove: false,
                responsive: [{
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                }, {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }, {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            };

            /* settings for the news slider */
            vm.newsSliderSettings = {
                dots: true,
                arrows: false,
                slidesToShow: 4,
                slidesToScroll: 4,
                touchMove: false,
                responsive: [{
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }, {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }, {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            };

            /* settings for the benifit slider */
            vm.partnershipSliderSettings = {
                dots: true,
                arrows: false,
                slidesToShow: 3,
                slidesToScroll: 3,
                touchMove: false,
                responsive: [{
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }]
            };
        }

        function bindingChanges(changes) {
            if (changes.sellerBanners) {
                if (changes.sellerBanners.currentValue) {
                    // vm.sellerPublic = Object.assign(changes.sellerPublic.currentValue, {
                    //     content: marked(changes.sellerPublic.currentValue.content || ''),
                    //     contactContent: marked(changes.sellerPublic.currentValue.contactContent || '')
                    // });
                } else {
                    vm.sellerPublic = changes.sellerPublic.currentValue;
                }
            }
        }

        /* product quanitity changed open toolbar */
        function productQuantityChanged() {
            vm.productsQuantityChanged = true;
            vm.productsAdded = false;
            vm.isOpen = true;
        }

        /* add product to cart */
        function addToCart() {
            vm.productsQuantityChanged = false;
            vm.addingProducts = true;
            vm.hasError = false;
            var addProducts = vm.discountsModel.products.concat(vm.productsModel.products);

            cartService.updateCartOverview(addProducts).then(function (result) {

                vm.addingProducts = false;
                vm.productsAdded = true;
                vm.addToCartEnabled = true;
                $scope.forms.productOverviewForm.$setPristine();
                var shoppingCartProducts = result;

                vm.discountsModel.products.map(function (discount) {
                    return discount = discount.getCartFields(discount, shoppingCartProducts);
                });

                vm.productsModel.products.map(function (product) {
                    return product = product.getCartFields(product, shoppingCartProducts);
                });

                $timeout(function () {
                    vm.productsAdded = false;
                    vm.isOpen = false;
                }, 5000);
            }).catch(function () {
                vm.addToCartEnabled = false;
                vm.addingProducts = false;
                var msg = gettextCatalog.getString('The product quantity could not be updated');
                exceptionService.logException(msg);
                vm.hasError = true;
                $timeout(function () {
                    vm.hasError = false;
                    vm.isOpen = false;
                }, 5000);
            });
        }

        /* Load product discounts when discount is clicked */
        function getProductDiscounts(product) {
            return productService.getProductDiscounts(product.id);
        }

        function moduleEnabled(module) {
            return (vm.sellerModules || []).indexOf(module) >= 0;
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/seller/detail.js
// module id = 1018
// module chunks = 0